import { MenuList } from '@mui/material';
import React from 'react';

import { MuiSxProps } from '../types';

import { DATA_OG } from '../enums';

interface IContextSwitcherMenuListContainerProps {
  children: React.ReactNode;
  dataTest: string;
  styleOverrides?: MuiSxProps;
}

export const ContextSwitcherMenuListContainer: React.FC<IContextSwitcherMenuListContainerProps> = ({
  dataTest,
  children,
  styleOverrides
}) => {
  return (
    <MenuList
      data-og={DATA_OG.context_switcher_container}
      data-test={dataTest}
      role="menu"
      sx={{ backgroundColor: 'background.paper', py: 0, ...styleOverrides }}
    >
      {children}
    </MenuList>
  );
};
